module.exports = __webpack_public_path__ + "media/src/images/icons/loading_secondary-cc70b3bee36aaf378d8f3f2015f26398.gif";